"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeChat = void 0;
var initializeChat = function (_a) {
    var id = _a.id, _b = _a.cookieCategory, cookieCategory = _b === void 0 ? 'cookie_cat_functional' : _b, callback = _a.callback;
    var giosgRoot = 'https://service.giosg.com';
    var giosgUrl = giosgRoot + "/live/";
    var element = document.createElement('script');
    element.setAttribute('async', 'true');
    element.src = '';
    element.dataset.consentSrc = giosgUrl;
    element.dataset.categoryConsent = cookieCategory;
    window._giosg = window._giosg || function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = (window._giosg._e = window._giosg._e || [])).push.apply(_a, args);
    };
    window._giosg._c = id;
    window._giosg._h = giosgRoot;
    document.head.insertBefore(element, document.head.firstElementChild);
    if (callback)
        callback();
};
exports.initializeChat = initializeChat;
